const config = {
  visibleDotLimit: 5, // Must be an odd number
  dotSize: 16,
  getMiddleVisibleDot: (): number => {
    return Math.ceil(config.visibleDotLimit / 2);
  },
  getWidth: (): number => {
    return config.dotSize * config.visibleDotLimit;
  },
};

const generateNumberRange = (start: number, end: number, length = end - start + 1): number[] =>
  Array.from({ length }, (_, i) => start + i);

export { config, generateNumberRange };
